var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareStroked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 12.5C11.25 12.9142 11.5858 13.25 12 13.25C12.4142 13.25 12.75 12.9142 12.75 12.5L12.75 4.81334L14.4702 6.53076C14.7633 6.82342 15.2382 6.82303 15.5309 6.5299C15.8235 6.23677 15.8231 5.76189 15.53 5.46924L12.5788 2.52285C12.5637 2.50455 12.5476 2.4868 12.5304 2.46967C12.4464 2.3856 12.3473 2.32567 12.2419 2.28986C12.166 2.26402 12.0846 2.25 12 2.25C11.8699 2.25 11.7475 2.28314 11.6408 2.34144C11.6212 2.35213 11.602 2.36376 11.5833 2.37632C11.542 2.40371 11.5028 2.43562 11.4664 2.47206C11.4589 2.47961 11.4515 2.48728 11.4444 2.49507L8.46978 5.46967C8.17689 5.76256 8.17689 6.23744 8.46978 6.53033C8.76268 6.82322 9.23755 6.82322 9.53044 6.53033L11.25 4.81077L11.25 12.5ZM5.25 20C5.25 20.9665 6.0335 21.75 7 21.75H17C17.9665 21.75 18.75 20.9665 18.75 20V10.5C18.75 9.5335 17.9665 8.75 17 8.75H15C14.5858 8.75 14.25 9.08579 14.25 9.5C14.25 9.91421 14.5858 10.25 15 10.25H17C17.1381 10.25 17.25 10.3619 17.25 10.5V20C17.25 20.1381 17.1381 20.25 17 20.25H7C6.86193 20.25 6.75 20.1381 6.75 20L6.75 10.5C6.75 10.3619 6.86193 10.25 7 10.25H9C9.41421 10.25 9.75 9.91421 9.75 9.5C9.75 9.08579 9.41421 8.75 9 8.75H7C6.0335 8.75 5.25 9.5335 5.25 10.5V20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareStroked);
export default __webpack_public_path__ + "static/media/ShareStroked.001a60fc399c0ecc297002daaed98143.svg";
export { ForwardRef as ReactComponent };